var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image 15 (traced)",
    clipPath: "url(#clip0_109_358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 857",
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FBBE08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7999 10.1257C20.3184 10.3518 19.8092 10.5022 19.2879 10.572C19.8372 10.221 20.248 9.66516 20.4422 9.00985C19.928 9.33829 19.3653 9.5696 18.7787 9.6938C18.4189 9.27983 17.9517 8.99201 17.438 8.86776C16.9243 8.7435 16.3877 8.78856 15.8981 8.99707C15.4084 9.20558 14.9884 9.5679 14.6925 10.0369C14.3966 10.5059 14.2387 11.06 14.2391 11.627C14.2371 11.8433 14.2575 12.0592 14.2999 12.2707C13.256 12.2156 12.2346 11.9239 11.3026 11.4146C10.3705 10.9052 9.54875 10.1898 8.89105 9.31509C8.55338 9.9367 8.44874 10.6736 8.59848 11.3755C8.74823 12.0774 9.14107 12.6913 9.69683 13.0918C9.28163 13.0798 8.87521 12.9604 8.51181 12.7438V12.7746C8.51249 13.4271 8.72193 14.0595 9.10485 14.5652C9.48778 15.071 10.0208 15.4192 10.6143 15.5514C10.3898 15.6151 10.1584 15.6464 9.92622 15.6444C9.75951 15.6476 9.59298 15.6314 9.42949 15.5961C9.59909 16.157 9.92595 16.6474 10.3651 16.9999C10.8042 17.3524 11.334 17.5497 11.8815 17.5646C10.9527 18.3468 9.80716 18.7711 8.628 18.7698C8.41807 18.7713 8.20827 18.7583 7.99988 18.7309C9.19977 19.5635 10.598 20.004 12.0254 19.999C16.8541 19.999 19.4942 15.6917 19.4942 11.9581C19.4942 11.8331 19.4902 11.7126 19.4846 11.5928C20.0022 11.1939 20.4479 10.6968 20.7999 10.1257Z",
    fill: "#FBBE08"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0f5944349e376bd0459583b019ecf4fb.svg";
export { ForwardRef as ReactComponent };